<template>
  <div
    :class="
      `accordion ${transparent ? 'accordion--transparent' : ''} ${
        dropdownOpen ? 'accordion--opened' : 'accordion--closed'
      }`
    "
  >
    <div
      @click="toggleAccordion()"
      :class="
        `${canOpen ? 'accordion__header' : ''}
         ${
           dropdownOpen
             ? 'accordion__header--opened'
             : 'accordion__header--closed'
         }`
      "
    >
      <ArrowIcon class="accordion__header-arrow" v-if="arrow" />
      <div v-if="title">{{ title }}</div>
      <div class="accordion__header-slot">
        <slot name="header" />
      </div>
    </div>
    <transition>
      <div v-if="dropdownOpen" class="accordion__body">
        <slot name="body" />
      </div>
    </transition>
  </div>
</template>

<script>
import ArrowIcon from '@/assets/icons/course/exercise/exercise-arrow.svg'

export default {
  components: {
    ArrowIcon: { ...ArrowIcon, name: 'ArrowIcon' },
  },
  props: {
    title: {
      type: String,
    },
    transparent: {
      type: Boolean,
      required: false,
    },
    arrow: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
    open: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
    canOpen: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
  },
  data: () => {
    return {
      dropdownOpen: true,
    }
  },
  methods: {
    toggleAccordion() {
      if (this.canOpen) {
        this.dropdownOpen = !this.dropdownOpen
        if (this.dropdownOpen) {
          this.$emit('open')
        }
      }
    },
  },
  created() {
    this.dropdownOpen = this.open
  },
}
</script>
<style lang="scss">
.accordion {
  $this: &;
  margin-bottom: 5px;
  &__header {
    display: flex;
    padding: 20px 35px;
    font-size: 14px;
    background: rgb(44, 44, 44);
    cursor: pointer;
    #{$this}__header-arrow {
      margin: 6px 10px;
      stroke: white;
      transition: all 0.2s ease-in-out;
    }
    &--closed {
      background: rgb(63, 63, 63);
      #{$this}__header-arrow {
        stroke: var(--orange);
        transform: rotate(-90deg);
      }
    }
    &--opened {
      border-bottom: 1px solid rgb(53, 52, 52);
    }
    &-slot {
      flex: 1;
    }
    &-slot > * {
      margin-left: 20px;
    }
  }
  &__body {
    overflow: auto;
    padding: 20px 40px;
    background: rgb(44, 44, 44);
  }
  &--transparent {
    #{$this}__header,
    #{$this}__body {
      background: transparent !important;
      &--closed {
        background: transparent !important;
      }
    }
  }
}
</style>
